// extracted by mini-css-extract-plugin
export default {"separator":"G3vI9ETS8q770eUtJ_0F","withBorder":"_Ye1iCsJfb5LEvhKH23F"};